import { render, staticRenderFns } from "./MyTableHeading.vue?vue&type=template&id=ab301364&scoped=true&"
import script from "./MyTableHeading.vue?vue&type=script&lang=js&"
export * from "./MyTableHeading.vue?vue&type=script&lang=js&"
import style0 from "./MyTableHeading.vue?vue&type=style&index=0&id=ab301364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab301364",
  null
  
)

export default component.exports